import loadable from '@loadable/component';

export const LoginPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "LoginPageContainer" */
      './LoginPageContainer.dynamic'
    ),
);
